import { useTranslation } from 'react-i18next';
import { useLanguage } from './useLanguage';

/**
 * Selettore lingua con bandierine PNG (pattern feelhippoai/Languages.tsx).
 * Usato dalla LoginPage (utente non loggato, no TopBar disponibile per cambio
 * lingua). La bandiera della lingua ATTIVA è renderizzata con opacity 0.3 e
 * cursore default per indicare "scelta corrente, non cliccabile"; le altre
 * sono opacity 1 + cursor pointer.
 *
 * Lingue supportate: it, en (allineate alle bandierine PNG in
 * /images/flags/{it,en}.png e ai locales i18n).
 *
 * Single source of truth via `useLanguage` hook (vedi `feedback_one_way_only`):
 * lo stesso hook è usato da `TopBar` post-login.
 */
const LANGUAGES = ['it', 'en'] as const;

export function LanguageSelector() {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="language-selector" role="group" aria-label={t('lang.current')}>
      {LANGUAGES.map((lng) => {
        const active = language === lng;
        const altKey = lng === 'it' ? 'lang.italiano' : 'lang.english';
        return (
          <img
            key={lng}
            src={`/images/flags/${lng}.png`}
            alt={t(altKey)}
            className={
              'language-selector__flag' +
              (active ? ' language-selector__flag--active' : '')
            }
            onClick={() => {
              if (!active) changeLanguage(lng);
            }}
          />
        );
      })}
    </div>
  );
}
